import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';
import { ModalRegisterComponent } from '../modal-register/modal-register.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetailRealEstateComponent } from '../detail-real-estate/detail-real-estate.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
declare var $: any;

@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.css']
})
export class ModalLoginComponent implements OnInit {
  showPassword: boolean = false;
  formLogin: FormGroup = this.createFormLogin();
  loginFlag: boolean = true;
  registroFlag: boolean = false;
  verifiedFlag: boolean = false;
  isLoginPage: boolean = false;
  capsLockActivated: boolean = false;

  constructor(
    private modal: NgbModal,
    private authSrv: AuthService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    public dialogRef: MatDialogRef<ModalLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public togglePassword() {
    this.showPassword = !this.showPassword;
  }

  ngOnInit(): void {
    this.email?.valueChanges.subscribe(() => {
      if (!this.email?.errors && this.email?.value !== null) {
        this.password?.enable();
      } else {
        this.password?.disable();
        this.password?.patchValue(null);
      };
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  openRegisterForm() {
    this.closeModal();
    this.router.navigateByUrl('/register');
    return;
  }

  openForgotPassword(){
    this.closeModal();
    this.openModalForgotPassword();
    return;
  }


  ////////////////////////////// LOGIN ///////////////////////////////////////////////
  createFormLogin() {
    return new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl({ value: null, disabled: true }, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(20),
        Validators.pattern(/[A-Z]/),
        Validators.pattern(/[a-z]/),
        Validators.pattern(/[0-9]/),
      ])
    })
  }

  get email() { return this.formLogin?.get('email'); }
  get password() { return this.formLogin?.get('password'); }

  async login() {
    if (this.formLogin.invalid) { return; }
    if (this.email?.value === null) { return; }
    if (this.password?.value === null) { return; }

    this.authSrv.login(this.email?.value, this.password?.value);
    this.formLogin.reset();
    this.closeModal();
  }

  async loginGoogle() {
    await this.authSrv.signInWithGoogle();
  }

  /** RESET PASSWORD */
  ////////////////////////////////////////////////////////////////////////////////////

  async resetPassword() {
    this.closeModal();
    const { value: email } = await Swal.fire({
      title: '',
      input: 'email',
      inputLabel: 'Necesitamos tu email',
      inputPlaceholder: 'Introduce tu email'
    })

    if (email) {
      this.authSrv.resetPassword(email);
    }
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.capsLockActivated = event.getModifierState('CapsLock');
  }

  openModalForgotPassword() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {disableClose:true, panelClass: 'modal-login-register'});

    dialogRef.afterClosed().subscribe(result => {
      console.log('El modal forgotPassword se ha cerrado');
    });
  }
}
